"use strict";
export function Notes() {}
Notes.prototype.create = function() {
  const df = document.createDocumentFragment();
  const container = document.createElement("div");
  container.className = "container--notes";
  df.appendChild(container);
  const note = document.createElement("p");
  note.appendChild(
    document.createTextNode(
      "※関連商品についてのご意見や初期不良等に関するお問い合わせは、"
    )
  );
  note.appendChild(
    document.createTextNode("各メーカー様のお問い合わせ窓口までお願いします。")
  );
  note.appendChild(document.createElement("br"));
  note.appendChild(document.createElement("br"));
  note.appendChild(
    document.createTextNode(
      "※税込価格で表示されている商品に関しましては発売当時の税率で表示しております。ご購入の際には実際の店舗等でご確認ください。"
    )
  );
  note.normalize();
  df.firstChild.appendChild(note);
  return df;
};
